import { useState } from "react";
import { addWitnessURL } from "../../utils/ConstantsURL";
import { toastAlert } from "../../utils/AlertContext";

export const useAddReferencesToNote = () => {
  const [isAddingReference, setIsAddingReference] = useState(false);

  const addReferencesToNote = async (
    id_sintesis,
    id_documento,
    id_seccion,
    id_referencias,
    fecha,
    token,
  ) => {
    setIsAddingReference(true);

    try {
      if (
        !id_sintesis ||
        !id_documento ||
        !id_seccion ||
        !id_referencias ||
        id_referencias.length === 0
      ) {
        throw new Error(
          "Faltan parámetros requeridos para agregar la referencia",
        );
      }

      const requestData = {
        id_sintesis: Number(id_sintesis),
        id_documento: Number(id_documento),
        id_seccion: Number(id_seccion),
        id_referencias: id_referencias.map(Number),
        fecha: fecha,
      };

      const response = await fetch(addWitnessURL(), {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });


      const responseText = await response.text();
      let responseData;
      try {
        responseData = JSON.parse(responseText);
      } catch (e) {
        throw new Error(
          `Server returned HTML/Text (Status ${response.status}). Check console.`,
        );
      }

      if (!response.ok) {
        if (responseData.errors && Array.isArray(responseData.errors)) {
          const errorMsg = responseData.errors.join(", ");
          throw new Error(`${responseData.message}: ${errorMsg}`);
        }
        throw new Error(
          responseData.message ||
            `Error ${response.status}: ${response.statusText}`,
        );
      }

      toastAlert("Testigos agregados exitosamente", "success");

      return { success: true, data: responseData };
    } catch (error) {
      toastAlert(
        error.message || "Error al agregar testigos a la nota",
        "error",
      );

      return { success: false, error: error.message };
    } finally {
      setIsAddingReference(false);
    }
  };

  return { addReferencesToNote, isAddingReference };
};

export default useAddReferencesToNote;
